import MineDamageLogic from "../../../logic/MineDamageLogic";
import OreCalculationLogic from "../../../logic/OreCalculationLogic";
import Totals from "../../crew/Totals";
import StatisticsIncrementor from "../../statistics/StatisticsIncrementor";
import Values from "../../value/Values";
import MinedDamageBonusUpgradeCreator from "./MinedDamageBonusUpgradeCreator";
import MinedOreBonusUpgradeCreator from "./MinedOreBonusUpgradeCreator";
import MinedUpgradeCollection from "./MinedUpgradeCollection";
import UpgradeCreator from "./UpgradeCreator";

export default class UpgradeCreators {
    /**
     * @param {Values} values 
     * @param {Totals} totals
     * @param {OreCalculationLogic} oreCalculationLogic
     * @param {MineDamageLogic} mineDamageLogic
     * @param {MinedUpgradeCollection} minedUpgradeCollection
     * @param {StatisticsIncrementor} statisticsIncrementor
     */
    constructor(values, totals, oreCalculationLogic, mineDamageLogic, minedUpgradeCollection, statisticsIncrementor) {

        /**
         * @constant
         * @type {Object}
         */
        this.creatorsById = {}; // All the upgrade creators need to be in this map.

        /**
         * @constant
         * @type {MinedUpgradeCollection}
         */
        this.minedUpgradeCollection = minedUpgradeCollection;

        /////////////////////////////////////
        // Mine Damage Bonus
        /////////////////////////////////////

        /**
         * @constant
         * @type {UpgradeCreator}
         */
        this.mineDamage = new MinedDamageBonusUpgradeCreator(values, mineDamageLogic);

        this.creatorsById[this.mineDamage.getId()] = this.mineDamage;

        /////////////////////////////////////
        // Mine Ore Bonus
        /////////////////////////////////////

        /**
         * @constant
         * @type {UpgradeCreator}
         */
        this.oreBonus = new MinedOreBonusUpgradeCreator(values, oreCalculationLogic, totals, statisticsIncrementor);

        this.creatorsById[this.oreBonus.getId()] = this.oreBonus;

    }

    /**
     * This is used by the save logic to get the correct upgrade creator.
     * @param {string} id 
     * @returns {UpgradeCreator}
     */
    getUpgradeCreatorById(id) {
        return this.creatorsById[id];
    }

    /**
     * Returns an upgrade creator for mined upgrades.
     * @returns {UpgradeCreator}
     */
    getUpgradeCreatorForDrop() {
        const selection = Math.random();
        if (selection < 0.65) {
            return this.oreBonus;
        }
        else {
            return this.mineDamage; // Mine damage should be more rare and desirable.
        }
    }
}